<template>
  <ul class="menu-nav">
    <li class="menu-item" v-for="item in menuItems" :key="item.id">
      <router-link :to="{ name: item.page }" class="menu-link">{{
        item.title
      }}</router-link>
    </li>
  </ul>
</template>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");
.menu-nav {
  margin-bottom: 0;
  list-style-type: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-item {
  margin-right: 2.3rem;
}

.menu-link {
  height: 19px;
  width: 55px;
  color: #222325 !important;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
  padding-bottom: 1rem;
}
.link-active {
  color: #6c6ce5 !important;
  border-bottom: 1px solid #6c6ce5;
}
</style>
<script>
import { GET_GROUPS } from "@/store/auth.module";
import { VERIFY_FEATURE_ARRAY } from "@/store/feature.module";
export default {
  name: "KTHeaderMenu",
  data() {
    return { menuItems: [] };
  },
  computed: {
    adminGroupName() {
      return "Admin";
    },
    merchantAdminGroupName() {
      return "MerchantAdmin";
    }
  },
  methods: {
    goToPage(page) {
      this.$router.push({ name: page }, () => {});
    },
    async updateFeaturesArray() {
      await this.$store.dispatch(VERIFY_FEATURE_ARRAY);
    },
    checkIfFeatureIsEnabled(featureName) {
      return !featureName || this.$store.getters.verifyFeature(featureName);
    },
    loadAdminGroup(groups) {
      if (!groups.includes(this.adminGroupName)) return [];

      return require(`@/common/config/menu.${this.adminGroupName.toLowerCase()}.config.json`).aside.items.filter(
        i => this.checkIfFeatureIsEnabled(i.featureName) && !!i.page
      );
    },
    loadMerchantAdminGroup(groups) {
      if (!groups.includes(this.merchantAdminGroupName)) return [];

      return require(`@/common/config/menu.${this.merchantAdminGroupName.toLowerCase()}.config.json`).aside.items.filter(
        i => this.checkIfFeatureIsEnabled(i.featureName) && !!i.page
      );
    },
    loadMerchantUserGroup(groups) {
      if (
        groups.includes(this.adminGroupName) ||
        groups.includes(this.merchantAdminGroupName)
      )
        return [];

      return require(`@/common/config/menu.merchantuser.config.json`).aside.items.filter(
        i => {
          return (
            this.checkIfFeatureIsEnabled(i.featureName) &&
            this.$role.verify(i.groups) &&
            !!i.page
          );
        }
      );
    }
  },
  async mounted() {
    await this.updateFeaturesArray();
    const groups = await this.$store.dispatch(GET_GROUPS);
    this.menuItems = this.menuItems.concat([
      //...this.loadAdminGroup(groups),
      ...this.loadMerchantAdminGroup(groups),
      ...this.loadMerchantUserGroup(groups)
    ]);
  }
};
</script>
